<template lang="html">
  <section>
    <div class="box">
      <div class="columns">
        <div class="column is-5">
          <b-tooltip :label="dateFromNow(itemData.attributes.updated_at)" animated>
            <router-link
              v-if="collectibleData.attributes.cover_image"
              :to="{
                path: `/${textPluralize(collectibleData.type)}/${collectibleData.id}`,
              }"
            >
              <figure class="image">
                <img
                  style="border-radius: 10%"
                  :src="collectibleData.attributes.cover_image"
                  alt=""
                />
              </figure>
            </router-link>
            <router-link
              v-else
              :to="{
                path: `/${textPluralize(collectibleData.type)}/${collectibleData.id}`,
              }"
            >
              <figure class="image">
                <img
                  style="border-radius: 10%"
                  src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_1x1.png"
                  alt=""
                />
              </figure>
            </router-link>
          </b-tooltip>
        </div>
        <div class="column is-7">
          <div class="columns is-marginless">
            <div class="column is-paddingless is-11">
              <router-link
                :to="{
                  path: `/${textPluralize(collectibleData.type)}/${collectibleData.id}`,
                }"
                ><p class="ellipsis2 has-text-weight-semibold">
                  {{ title }}
                </p></router-link
              >
            </div>
            <div class="column is-paddingless is-narrow">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <p class="clickable" slot="trigger" role="button">
                  <b-icon size="is-small" type="is-success" icon="pencil"></b-icon>
                </p>
                <b-dropdown-item
                  @click="removeItem"
                  aria-role="listitem"
                  class="has-text-danger"
                  ><b-icon size="is-small" icon="trash-can"></b-icon
                  >Remove</b-dropdown-item
                >
                <b-dropdown-item
                  @click="isComponentModalActive = true"
                  aria-role="listitem"
                  class="has-text-success"
                  ><b-icon size="is-small" icon="transfer-right"></b-icon
                  >Transfer</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <p>
            <b-tooltip
              :delay="500"
              animated
              type="is-light"
              :label="collectibleData.type"
            >
              <span v-if="collectibleData.type == 'project'">
                <b-icon
                  type="is-gray"
                  size="is-small"
                  icon="folder-multiple-outline"
                ></b-icon
              ></span>

              <span v-if="collectibleData.type == 'craft'">
                <b-icon type="is-gray" size="is-small" icon="wrench"></b-icon
              ></span>

              <span v-if="collectibleData.type == 'article'">
                <b-icon
                  type="is-gray"
                  size="is-small"
                  icon="newspaper-variant-outline"
                ></b-icon
              ></span>
            </b-tooltip>
            {{ textTitleize(collectibleData.type) }}
          </p>
          <span class="ellipsis2 is-italic has-text-gray is-size-7"
            >From

            <router-link
              :to="{ path: `/users/${collectibleData.attributes.user_username}` }"
              >@{{ collectibleData.attributes.user_cosplayer_name }}</router-link
            >
          </span>
        </div>
      </div>
    </div>

    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: auto">
        <!-- Header -->
        <header class="modal-card-head">
          <p class="modal-card-title">Transfer to Collection</p>
          <button type="button" class="delete" @click="isComponentModalActive = false" />
        </header>

        <!-- Collections Selection -->
        <section class="modal-card-body">
          <div v-for="collection in collections" :key="collection.id">
            {{ collection.attributes.name }}
            <b-button
              :disabled="isInCollection(collection.attributes.collection_items)"
              @click="transferToCollection(collection.id)"
              type="is-primary is-light"
              >Transfer</b-button
            >
          </div>
        </section>

        <!-- Footer -->
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isComponentModalActive = false">
            Close
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { dateMixin } from '@/mixins/dateMixin'
import { textMixin } from '@/mixins/textMixin'
export default {
  props: ['item', 'collections'],
  mixins: [dateMixin, textMixin],
  data () {
    return {
      isComponentModalActive: false
    }
  },
  computed: {
    itemData () {
      return this.item.data
    },
    collectibleData () {
      return this.item.content.data
    },
    title () {
      switch (this.collectibleData.type) {
        case 'project':
          return `${this.collectibleData.attributes.title}`
        case 'craft':
          return `${this.collectibleData.attributes.name}`
        case 'article':
          return `${this.collectibleData.attributes.title}`
        default:
          return 'Undefined'
      }
    }
  },
  methods: {
    removeItem () {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.$store
            .dispatch('collectionItems/destroy', this.itemData.id)
            .then((resp) => {
              this.$emit('collectionsUpdated', resp.data.data)
            })
            .catch((_) => {
              console.log('Collection destroy error')
            })
          this.$buefy.toast.open('User confirmed')
        }
      })
    },
    isInCollection (collectionItems) {
      return collectionItems.some((item) => {
        return String(item.data.id) === String(this.itemData.id)
      })
    },
    transferToCollection (collectionId) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure?',
        onConfirm: () => {
          this.$store
            .dispatch('collectionItems/update', {
              collectionId: collectionId,
              collectionItemId: this.itemData.id
            })
            .then((resp) => {
              this.$emit('collectionsUpdated', resp.data.data)
              this.isComponentModalActive = false
            })
            .catch((_) => {
              console.log('Collection update error')
            })
          this.$buefy.toast.open('User confirmed')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
